import React, { Component, Fragment } from "react";
import "../../styles/Popup.module.css";
import { Form, Input } from "antd";
import { connect } from "react-redux";
import { requestServerPost, selectPage } from "../../actions";
import PopupManager from "../../managers/PopupManager";
import ColorPicker from "../ColorPicker";
import Colors from "../../config/Colors";
import LayoutTemplates from "../../data/LayoutTemplates";
import { CalendarDays } from "lucide-react";
import {
  useProLanguage,
  PRO_TRANSLATIONS,
} from "../../global/ProLanguageContext";

const formItemLayout = {
  labelCol: { span: 0 },
  wrapperCol: { span: 24 },
};

class CreateTimelinePage extends Component {
  constructor(props) {
    super(props);
    const { data = null } = props;

    const timelineName = data ? data.TimelineName : "";

    if (!data || !data.BrandLogo || data.BrandLogo === "") {
      this.state = {
        timelinename: timelineName,
        fileList: [],
        files: [],
        data: data,
        loading: false,
      };

      return;
    }

    this.state = {
      timelinename: timelineName,
      data: data,
      color: null,
      loading: false,
    };
  }

  componentDidMount() {
    const { data = null } = this.props;

    if (data)
      this.setState({
        color: data.Color ? data.Color : Colors.defaulttimeline,
      });
    else this.setState({ color: Colors.defaulttimeline });
  }
  createTimelineLayout = (timelineID) => {
    const {
      requestServerPost,
      usertoken,
      data = null,
      selectedBrandData,
      campaignData,
    } = this.props;
    return new Promise((resolve, reject) => {
      var params = new FormData();
      params.append("brandid", selectedBrandData.BrandID);
      params.append("timelineid", timelineID);
      params.append("layout", JSON.stringify(LayoutTemplates.templates[0]));
      params.append("duration", 0);
      requestServerPost(
        "create_timelinelayout",
        params,
        {},
        (response) => {
          resolve();
        },
        usertoken,
      );
    });
  };
  onFinish = (values) => {
    if (this.state.loading) return;

    const {
      requestServerPost,
      usertoken,
      data = null,
      selectedBrandData,
      campaignData,
    } = this.props;
    var params = new FormData();

    console.log("campaignData " + JSON.stringify(campaignData));
    const { CampaignID } = campaignData;

    params.append("campaignid", CampaignID);

    this.setState({ loading: true });

    if (!data) {
      params.append("brandid", selectedBrandData.BrandID);
      params.append("timelinename", values.timelinename);
      params.append("color", this.state.color);

      requestServerPost(
        "create_timeline",
        params,
        {},
        (response) => {
          const { timelineid } = response.data;

          this.createTimelineLayout(timelineid).then(() => {
            PopupManager.closePopup();
          });
        },
        usertoken,
        {},
        () => {
          this.setState({ loading: false });
        },
      );
    } else {
      params.append("brandid", selectedBrandData.BrandID);
      params.append("timelineid", data.TimelineID);
      params.append("timelinename", values.timelinename);
      params.append("color", this.state.color);

      requestServerPost(
        "update_timeline",
        params,
        {},
        (response) => {
          PopupManager.closePopup();
        },
        usertoken,
        {},
        () => {
          this.setState({ loading: false });
        },
      );
    }
  };

  onColorChanged = (newcolor) => {
    this.setState({ color: newcolor });
  };
  render() {
    const { data = null } = this.props;
    const t = this.props.langT || PRO_TRANSLATIONS.en.createTimelinePopup;
    const previewStyle = {
      display: "inline",
      width: 100,
      height: 100,
    };
    const color = data
      ? data.Color
        ? data.Color
        : Colors.defaulttimeline
      : Colors.defaulttimeline;
    const bleed = { margin: -24, overflow: "hidden" };
    const body = { maxWidth: 440, margin: "0 auto", padding: "32px 40px" };

    return (
      <div style={{ ...bleed }}>
        <div
          style={{
            background: "linear-gradient(135deg,#6366f1 0%,#4f46e5 100%)",
            padding: "36px 40px",
            textAlign: "center",
            color: "#fff",
          }}
        >
          <div
            style={{
              width: 56,
              height: 56,
              borderRadius: 16,
              background: "rgba(255,255,255,0.2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              margin: "0 auto 14px",
            }}
          >
            <CalendarDays size={28} color="#fff" />
          </div>
          <div style={{ fontSize: 22, fontWeight: 700, marginBottom: 6 }}>
            {data ? t.editTitle : t.createTitle}
          </div>
          <div style={{ fontSize: 14, color: "rgba(255,255,255,0.75)" }}>
            {data
              ? `${t.editSubtitlePrefix} "${data.TimelineName}"`
              : t.createSubtitle}
          </div>
        </div>
        <div style={{ ...body }}>
          <Form
            name="create_timeline_form"
            {...formItemLayout}
            onFinish={this.onFinish}
            key={data ? `${data.TimelineID}_edittimeline` : "_edittimeline"}
            initialValues={{ timelinename: this.state.timelinename }}
            onValuesChange={(_, all) =>
              this.setState({ timelinename: all.timelinename || "" })
            }
          >
            <div style={{ marginBottom: 20 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 6,
                }}
              >
                {t.nameLabel}
              </label>
              <Form.Item
                name="timelinename"
                style={{ marginBottom: 0 }}
                rules={[{ required: true, message: t.nameValidation }]}
              >
                <Input
                  size="large"
                  placeholder={t.namePlaceholder}
                  style={{ borderRadius: 10 }}
                  autoFocus
                />
              </Form.Item>
            </div>
            <div style={{ marginBottom: 28 }}>
              <label
                style={{
                  fontSize: 12,
                  fontWeight: 600,
                  color: "#64748b",
                  textTransform: "uppercase",
                  letterSpacing: "0.05em",
                  display: "block",
                  marginBottom: 10,
                }}
              >
                {t.colourLabel}
              </label>
              <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
                <ColorPicker
                  color={color}
                  onColorChange={this.onColorChanged}
                />
                <span
                  style={{
                    fontSize: 13,
                    color: "#64748b",
                    fontFamily: "monospace",
                  }}
                >
                  {color}
                </span>
              </div>
            </div>
            <Form.Item style={{ marginBottom: 0 }}>
              <button
                type="submit"
                style={{
                  width: "100%",
                  height: 48,
                  borderRadius: 10,
                  border: "none",
                  background: "linear-gradient(135deg,#6366f1,#4f46e5)",
                  color: "#fff",
                  fontSize: 15,
                  fontWeight: 600,
                  cursor: "pointer",
                  boxShadow: "0 2px 10px rgba(99,102,241,0.3)",
                }}
              >
                {data ? t.saveButton : t.createButton}
              </button>
            </Form.Item>
          </Form>
        </div>
      </div>
    );
  }
}

const Styles = {};

const mapStateToProps = (state) => {
  return {
    userdata: state.userdata,
    usertoken: state.usertoken,
    selectedBrandData: state.selectedBrandData,
  };
};

const ConnectedCreateTimelinePage = connect(mapStateToProps, {
  requestServerPost,
  selectPage,
})(CreateTimelinePage);

const CreateTimelinePageWithLang = (props) => {
  const { lang } = useProLanguage();
  const t =
    PRO_TRANSLATIONS[lang]?.createTimelinePopup ||
    PRO_TRANSLATIONS.en.createTimelinePopup;
  return <ConnectedCreateTimelinePage langT={t} {...props} />;
};

export default CreateTimelinePageWithLang;
